import React, { useEffect } from 'react';
import {
  CContainer,
  CRow,
  CCol,
  CCard,
  CCardBody,
  CCardHeader,
  CBreadcrumb,
  CBreadcrumbItem,
} from '@coreui/react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import StockStatusInputs from '../../components/StockStatusInputs/StockStatusInputs';
import { connect } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';
import {
  updateStockStatusRequestAction,
} from '../../store/stockStatus/stockStatusActions';

const UpdateStockStatus = (props) => {
  const {
    updateStockStatusRequest,
    isLoading,
    updateStockStatusData,
  } = props;

  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const { t } = useTranslation();

  const stockStatusData = location.state?.stockStatus || null;

  useEffect(() => {
    if (!stockStatusData && id) {
      console.warn('No stock status data found in route state. You may need to fetch by ID:', id);
    }
  }, [stockStatusData, id]);

  const handleStockSubmit = (stockStatusData) => {
    console.log('Submitting updated stock:', stockStatusData);
    updateStockStatusRequest({
      data: stockStatusData,
      navigate: navigate
    });
  };

  const handleBackToStock = () => {
    navigate('/stock-status');
  };

  return (
    <div>
      <CContainer>
        <CBreadcrumb className="mb-4">
          <CBreadcrumbItem 
            href="#/stock-status" 
            onClick={(e) => {
              e.preventDefault();
              handleBackToStock();
            }}
          >
            {t('stockStatus')}
          </CBreadcrumbItem>
          <CBreadcrumbItem active>{t('updateStockStatus')}</CBreadcrumbItem>
        </CBreadcrumb>

        <CRow>
          <CCol xs={12}>
            <CCard>
              <CCardHeader>
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="mb-0">{t('updateStockStatus')}</h4>
                  {stockStatusData?.StockStatusId && (
                    <small className="text-muted">
                      {t('ID')}: {stockStatusData.StockStatusId}
                    </small>
                  )}
                </div>
              </CCardHeader>
              <CCardBody>
                {stockStatusData ? (
                  <StockStatusInputs 
                    onSubmit={handleStockSubmit}
                    onCancel={handleBackToStock}
                    isLoading={isLoading}
                    submitResponse={updateStockStatusData}
                    initialData={stockStatusData}
                    isEdit={true}
                  />
                ) : (
                  <div className="text-center py-4">
                    <div className="text-muted">
                      {t('No stock status data found. Please go back to the stock list.')}
                    </div>
                    <button 
                      className="btn btn-primary mt-3"
                      onClick={handleBackToStock}
                    >
                      {t('Back to Stock')}
                    </button>
                  </div>
                )}
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isLoading: state.loadingReducer?.isLoading || false,
    updateStockStatusData: state.stockStatusReducer?.updateStockStatusData || null,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateStockStatusRequest: (payload) => {
      dispatch(updateStockStatusRequestAction(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateStockStatus);
